/**
 * URLs the browser OTel FetchInstrumentation (lib/otel/tracer.ts) must NOT
 * trace. Lives in its own side-effect-free module so it can be unit-tested
 * in-process: importing tracer.ts boots the WebTracerProvider and patches
 * `fetch` at module scope (see telemetryBootSites.test.ts, which only imports
 * it in a subprocess for that reason).
 *
 * Skip fetches that aren't part of "the user did something" — telemetry-of-
 * telemetry would loop, third-party SDKs would pollute Kibana with hostnames
 * we don't own, and silent OIDC renewals fire constantly without diagnostic
 * value.
 */
export const OTEL_FETCH_IGNORE_URLS: readonly RegExp[] = [
  // The exporters' own posts to the BFF — /diag/ingest (OTLP traces) would
  // loop the exporter into itself, and /diag/logs (the console→OTLP log
  // bridge) would emit a span per log batch. Exactly those two paths, so no
  // other BFF route that merely starts with them goes untraced.
  /\/diag\/(?:ingest|logs)(?:$|\?)/,
  // Sentry tunnel route (next.config.mjs `tunnelRoute: "/monitoring"`)
  /\/monitoring/,
  // Mixpanel analytics
  /api(-eu)?\.mixpanel\.com/,
  // Whitelabel S3 assets
  /\.amazonaws\.com/,
  // OIDC silent renewal / authorize / token / userinfo flows
  /\/(?:auth|oidc|realms)\/.+\/(?:authorize|token|userinfo|\.well-known|logout)/,
  // Turnstile (Cloudflare bot detection used in registration)
  /challenges\.cloudflare\.com/,
];
